import { ConfirmModal } from '@/shared/ui/components';
import { t } from 'ttag';
import { useModalC1cReport } from './useModalC1cReport';

const ModalC1cReport = () => {
  const { isOpen, onClose } = useModalC1cReport();

  return (
    <ConfirmModal
      isOpen={isOpen}
      title={t`Cannot open report`}
      question={t`This report can only be viewed and signed in the CardioOne portal.`}
      rightButtonName={t`OK`}
      onClickRightButton={onClose}
    />
  );
};

export default ModalC1cReport;
